import { useGetSlotPageQuery } from "../api/controllers/slot"
import { useAppSelector } from "../store/hooks"
import { selectCurrentProjectId } from "../store/projects/selectors"

export const useSlots = (queryProjectId?: string) => {
    const currentProjectId = useAppSelector(selectCurrentProjectId)
    const projectId = queryProjectId || currentProjectId || ""
    const { data, refetch } = useGetSlotPageQuery({ projectId }, { skip: !projectId })

    return {
        slots: data?.Items ?? [],
        refetchSlots: refetch
    }
}
